/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![LocationIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABdElEQVR4nMWTsU4CQRCGV3kAW8VWLS3sNNFGaYTZ2TNZ/iE+h54d4Qm0VV7DxsZASaSigSewEwts1EKzRAmB2+XuMHGSP7lsZv9vZnZOqf8OiqREBk0yMtAGb2Mx+sS407p6ktvYGOyQkbY28hUUo1U+q21nMte6eqQNhgvNJ8KQGYepK89mLmMRywuR3VoIICOPWc31L8RIO2weSSmvuf5RhXEcqB5NT/vvxHKptRSdiBG7Mw/kNjSeQTIA8VwuI/ZsVd8PYBklXYqi843Z3FNr1z3djkIjek2sSktxNrdctpu+lQ0BumlHpA2ukjcJ3dCIbvyPjDjdI+PaC2DGwdJramr7XoBSaoUMevl/NPScRwjgukDuDiJYtSjq9fqq77F1uPond1elCSLZJcZHBsBnJarupTKfQFgaqatnaWQyn4yKcb8QwPJgrS2oPGGtXSNGx185Oi4nl/k0RDNa85WjtbT5FKSgDS6I8ezkvnOP5a/jG0+QKUZEp9zfAAAAAElFTkSuQmCC)
 */
export const LocationIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M12 23c3 0 9-8.03 9-13a9 9 0 1 0-18 0c0 4.97 6 13 9 13Zm0-10a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
